import { render } from "./ChangeRoleModal.vue?vue&type=template&id=194f3d04"
import script from "./ChangeRoleModal.vue?vue&type=script&lang=js"
export * from "./ChangeRoleModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__